import React from 'react'

interface IconProps {
  color?: string
  size?: number
  className?: string
}

export const TwoArrowsIcon: React.FC<IconProps> = ({
  color = '#fff',
  size = 24,
  className,
  ...rest
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    className={className}
    {...rest}
  >
    <g
      opacity={color ? 1 : 0.4}
      fillRule="evenodd"
      clipRule="evenodd"
      fill={color}
    >
      <path d="M16.983 11.646a.5.5 0 01-.707 0l-.493-.493a.5.5 0 010-.708l2.731-2.732H3.072a.5.5 0 01-.5-.5V6.5a.5.5 0 01.5-.5h15.442l-2.73-2.732a.5.5 0 010-.707l.493-.493a.5.5 0 01.707 0l4.19 4.19a.83.83 0 010 1.2l-4.191 4.189zm-9.964.706a.5.5 0 01.707 0l.493.492a.5.5 0 010 .708l-2.733 2.732H20.93a.5.5 0 01.5.5v.714a.5.5 0 01-.5.5H5.486L8.22 20.73a.5.5 0 010 .708l-.493.492a.5.5 0 01-.707 0l-4.19-4.189a.83.83 0 010-1.2l4.19-4.19z" />
      <path d="M15.78 12.14l-.493-.492a1.2 1.2 0 010-1.697l1.536-1.538H3.071a1.2 1.2 0 01-1.2-1.2v-.714a1.2 1.2 0 011.2-1.2h13.753l-1.537-1.538a1.2 1.2 0 010-1.696l.494-.493a1.2 1.2 0 011.697 0l4.184 4.184a1.528 1.528 0 010 2.2l-4.185 4.184a1.2 1.2 0 01-1.697 0zm5.392-4.684a.83.83 0 000-1.2l-4.19-4.19a.5.5 0 00-.706 0l-.493.494a.5.5 0 000 .707l2.73 2.732H3.071a.5.5 0 00-.5.5v.714a.5.5 0 00.5.5h15.442l-2.732 2.732a.5.5 0 000 .707l.494.494a.5.5 0 00.707 0l4.19-4.19zm-12.952 4.4l.493.494a1.2 1.2 0 010 1.697l-1.538 1.537h13.753a1.2 1.2 0 011.2 1.2v.714a1.2 1.2 0 01-1.2 1.2H7.175l1.538 1.537a1.2 1.2 0 010 1.698l-.493.492a1.2 1.2 0 01-1.697 0l-4.185-4.184a1.53 1.53 0 010-2.2l4.185-4.184a1.2 1.2 0 011.697 0zm-5.392 5.885l4.19 4.19a.5.5 0 00.707 0l.493-.494a.5.5 0 000-.707l-2.733-2.732h15.443a.5.5 0 00.5-.5v-.714a.5.5 0 00-.5-.5H5.485l2.733-2.732a.5.5 0 000-.708l-.493-.492a.5.5 0 00-.707 0l-4.19 4.189a.829.829 0 000 1.2z" />
    </g>
  </svg>
)
